import { prePrimaryGrades, postPrimaryGrades, GRADES } from 'constants/constants';

export const FORM_ACTIONS = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  ENROL: 'ENROL',
};

export const PII_HIDDEN_FORM_ACTIONS = [FORM_ACTIONS.VIEW, FORM_ACTIONS.EDIT];

const ACT = 'ACT';
const FDTR = 'FDTR';
const INTR = 'INTR';

export const teacherStates = {
  EXCLUDE_INACT: [ACT, FDTR, INTR],
  EXCLUDE_INACT_INTR: [ACT, FDTR],
};

const REGULAR = 'REGULAR';
const PLUS = 'PLUS';
export const ENROLLMENT_TYPE = {
  REGULAR: REGULAR,
  PLUS: PLUS,
  HYBRID: 'HYBRID',
  HYBRID_PLUS: 'HYBRID_PLUS',
  CLASS_K5: 'CLASS_K5',
};

export const HYBRID_ENROLLMENT_TYPES = [
  ENROLLMENT_TYPE.HYBRID,
  ENROLLMENT_TYPE.HYBRID_PLUS,
  ENROLLMENT_TYPE.CLASS_K5,
];

export const ERROR_MSG_FOR_TEACHER_LIST = 'Please enter more than 4 characters';

export const USERNAME_LENGTH = 29;

export const STUDENT_SOURCE = {
  FOUNDATION: 'Foundation',
};

export const MENU_CLOSE = 'menu-close';

export const MODAL_CONFIRMATION_ACTIONS = {
  CONFIRMED: 'confirmed',
  CANCEL: 'cancel',
  CONFIRM: 'Confirm',
};

export const PATCH_ACTION = {
  DISABLE: 'DISABLE_TEACHER',
  NOT_INTERESTED: 'MARK_NOT_INTERESTED',
  PAID: 'PAID',
  SET_SCHEDULE: 'SET_SCHEDULE',
  SET_RM_CALL: 'SET_RM_CALL',
  UPDATE: 'UPDATE_DEMO',
};

export const STUDENT_ACTION_DATA = {
  NOT_INTERESTED: 'NOT_INTERESTED',
  PAID: 'PAID',
  NONE: 'REASSIGNED',
};

export const MODAL_FORM = {
  ADD_NEW_ACTIVITY_MODAL: 'addNewActivityCard',
  ADD_SHEET_MODAL: 'addSheetModal',
  ADD_TOPIC_MODAL: 'addTopicModal',
  ASSIGN_TEACHER: 'assignTeacherModal',
  ASSIGN_TEACHER_CONTAINER: 'assignTeacherModalContainer',
  BULK_EDIT_MODAL: 'bulkEditmodal',
  BULK_RM_ASSIGNMENT_MODAL: 'bulkRMAssignmentModal',
  CONFIRMATION: 'confirmationModal',
  COURSE_CLASS_LOG_ACTION_MODAL: 'courseClassLogActionModal',
  CREATE_DEMO_SLOT: 'demoSlotCreationModal',
  CREATE_NEW_ACTIVITY_MODAL: 'createNewActivityModal',
  DISABLE_TEACHER: 'disableTeacherModal',
  EDIT_ACTIVITY_MODAL: 'editActivityModal',
  EDIT_FILTER_MODAL: 'editFilterModal',
  EDIT_STUDENT_REGION: 'editStudentRegion',
  EDIT_STUDENT_SLOT: 'editStudentSlotModal',
  EDIT_STUDENT_USERNAME: 'editStudentUsernameModal',
  EDIT_STUDENT_PHONE: 'editStudentPhoneModal',
  EDIT_STUDENT_EMAIL: 'editStudentEmailModal',
  ELECTIVE_COURSES_MODAL: 'electiveCoursesModal',
  EXTRA_PRACTICE_MODAL: 'extraPracticeModal',
  FOUNDATION_PAYMENT_MODAL: 'foundationPaymentModal',
  NEW_PAYMENT: 'newPaymentModal',
  ONLINE_PLANS_PRICING_MANAGEMENT_MODAL: 'onlinePlansPricingManagementModal',
  WORKBOOK_DISPATCHED_UPLOAD_MODAL: 'workbookDispatchedUploadModal',
  STUDENT_PAYMENT_MODAL: 'studentPaymentModal',
  PARENTSTUDENT: 'parentStudentModal',
  PAYMENT_CONFIRM_MODAL: 'paymentConfirmModal',
  PAYMENT_DATA_UPLOAD_MODAL: 'paymentDataModal',
  PAYMENT: 'paymentModal',
  PAYMENT_FLOW_OVERRIDES: 'paymentFlowOverridesModal',
  PAYMENT_FLOW_GUIDE: 'paymentFlowGuideModal',
  PHONE: 'phoneModal',
  REGION_PAYOUT_BULK_CONFIRM_MODAL: 'regionPayoutBulkConfirmModal',
  REGION_PAYOUT_EDIT_END_MODAL: 'regionPayoutEditEndModal',
  REVIEW_CONFIRM_MODAL: 'reviewConfirmModal',
  REVIEW_TYPE_MODAL: 'reviewTypeModal',
  RM_FORM: 'relationshipManagerModal',
  SEARCH_FILTER_MODAL: 'searchFilterModal',
  STUDENT_DEMO: 'studentDemoForm',
  STUDENT: 'studentForm',
  TEACHER_CRED_FORM: 'teacherCredForm',
  TEACHER: 'teacherForm',
  UPDATE_DEMO: 'updateDemoModal',
  TOGGLE_RM_CALL: 'toggleRMCall',
  SUCCESS_MODAL: 'successModal',
  MAPPING_RATING: 'mappingRatingModal',
  AUTO_MAPPING_MODAL: 'autoMappingModal',
  MAPPER_MAPPING_MODAL: 'mapperMappingModal',
  ASSIGN_TEACHER_TO_LEAD: 'assignTeacherToLead',
  AC_LED_MAPPING_TEACHERS_MODAL: 'acLedMappingTeachersModal',
  EDIT_TEACHER_LICENSE_MODAL: 'editTeacherLicenseModal',
  AC_LED_MAPPING_BOOK_TRIAL_CLASS_MODAL: 'acLedMappingBookTrialClassModal',
  AC_LED_MAPPING_BASIC_CONFIRMATION_MODAL: 'acLedMappingBasicConfirmationModal',
  AC_LED_MAPPING_RESULT_FEEDBACK_MODAL: 'acLedMappingResultFeedbackModal',
  CSM_ASSIGNMENT_MODAL: 'csmAssignmentModal',
  PAUSE_UNITS_MODAL: 'pauseUnitsModal',
  CONFIRMATION_MODAL: 'confirmationModal',
  CHANGE_CRM_PARENT: 'changeCrmParent',
  CHANGE_CRM_GRADE: 'changeCrmGrade',
  ASSIGN_TEACHER_TO_SAT_DEMO: 'assignTeacherToSATDemoModal',
};

export const MODAL_TYPE = {
  TOGGLE_RM_CALL: 'Toggle_RM_Call',
  UPDATE: 'Update',
  DISABLE: 'Disable',
  PAID: 'Paid',
  NOT_INTERESTED: 'Not_Interested',
};

export const FIELD_TYPES = {
  INPUT: 'INPUT',
  SELECT: 'SELECT',
  CRITERIA: 'CRITERIA',
  RADIO: 'RADIO',
};

const { INPUT, SELECT, CRITERIA, RADIO } = FIELD_TYPES;

export const STUDENT_TYPE = {
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
};

export const USER_TAB = {
  ACCOUNT: 0,
  PROFILE: 1,
  SLOTS: 2,
};

export const PAYMENT_STATUS = {
  CONFIRMED: 'CNF',
  CREATED: 'ACT',
};

export const PAYMENT_TYPE = {
  ONE_TIME_PAYMENT: 'ONE_TIME_PAYMENT',
  SUBSCRIPTION: 'SUBSCRIPTION',
};

export const defaultDate = '2022-04-22';

export const defaultDemoDate = new Date().toISOString();
const defaultNow = new Date(Date.now() + 5 * 60000);
const defaultLocalDate = `${defaultNow.getFullYear()}-${String(
  defaultNow.getMonth() + 1,
).padStart(2, '0')}-${String(defaultNow.getDate()).padStart(2, '0')}`;
const defaultLocalTime = `${String(defaultNow.getHours()).padStart(2, '0')}:${String(
  defaultNow.getMinutes(),
).padStart(2, '0')}`;

export function getOnChangeMethod(param) {
  return `on${param}Change`;
}

export function getInputChangeMethod(field) {
  switch (field.fieldType) {
    case INPUT:
      return `on${field.name}Change`;
    case SELECT:
      return 'onOptionChange';
    case FIELD_TYPES.CHECKBOX:
      return 'onToggle';
    default:
      return null;
  }
}

export function updateFieldChoices(fields, formFields, choicesList) {
  return fields.map(
    fieldName =>
      (formFields.find(field => field.name === fieldName).choices = choicesList),
  );
}

export function dynamicClassRatioOptions(onlinePlanOptions) {
  return Array.from(new Set(onlinePlanOptions.map(planOptions => planOptions)))
    .sort((planOptionsA, planOptionsB) => planOptionsA - planOptionsB)
    .map(classRatio => ({
      label: `1:` + classRatio,
      value: classRatio,
    }));
}

export function getHeadText(formType, userType) {
  if (formType === FORM_ACTIONS.CREATE) {
    return `Create ${userType}`;
  } else if (formType === FORM_ACTIONS.EDIT) {
    return `Edit ${userType} Details`;
  } else {
    return `View ${userType} Details`;
  }
}

export const demoIncentiveIds = [
  {
    name: 'student_id',
    label: 'Student ID',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'student_id',
  },
  {
    name: 'teacher_id',
    label: 'Teacher ID',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'teacher_id',
  },
];

export const demoIncentiveReasonFields = [
  {
    name: 'payment_id',
    label: 'Payment ID',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'payment_id',
  },
  {
    name: 'reason',
    label: 'Reason',
    fieldType: SELECT,
    required: true,
    editable: true,
    multiple: true,
    default: '',
    param: 'reason',
  },
  {
    name: 'other_reason',
    label: 'Type your reason',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'other_reason',
  },
];

export const parentFields = [
  {
    name: 'firstName',
    label: 'First Name',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: false,
    default: '',
    param: 'first_name',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    default: '',
    param: 'last_name',
  },
  {
    name: 'phone',
    label: 'Primary Phone',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: false,
    default: '',
    param: 'phone',
  },
  {
    name: 'email',
    label: 'Email',
    fieldType: INPUT,
    type: 'email',
    required: true,
    editable: false,
    default: '',
    param: 'email',
  },
];

export const studentFields = [
  {
    name: 'student_id',
    label: 'Student Id',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'id',
    disabled: true,
    profileView: false,
  },
  {
    name: 'firstName',
    label: 'First Name',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'first_name',
    profileView: false,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'last_name',
    profileView: false,
  },
  {
    name: 'phone',
    label: 'Primary Phone',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: false,
    default: '',
    param: 'phone',
    profileView: false,
    forCreate: true,
  },
  {
    name: 'countryCode',
    label: 'Country Code',
    fieldType: SELECT,
    required: false,
    editable: false,
    default: '',
    param: 'country_code',
    profileView: false,
    forCreate: true,
  },
  {
    name: 'alternatePhone',
    label: 'Alternate Phone',
    fieldType: INPUT,
    type: 'number',
    required: false,
    editable: false,
    default: '',
    param: 'alternate_phone',
    profileView: false,
  },
  {
    name: 'username',
    label: 'Username',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: false,
    default: '',
    param: 'username',
    profileView: false,
    forCreate: true,
  },
  {
    name: 'password',
    label: 'Password',
    fieldType: INPUT,
    type: 'password',
    required: true,
    editable: true,
    default: '',
    param: 'password',
    profileView: false,
  },
  {
    name: 'confirmPassword',
    label: 'Confirm Password',
    fieldType: INPUT,
    type: 'password',
    required: true,
    editable: true,
    default: '',
    profileView: false,
  },
  {
    name: 'email',
    label: 'Email',
    fieldType: INPUT,
    type: 'email',
    required: true,
    editable: true,
    default: '',
    param: 'email',
    profileView: false,
  },
  {
    name: 'gender',
    label: 'Student Gender',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'gender',
    profileView: false,
  },
  {
    name: 'parentName',
    label: 'Parent Name',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'parent_name',
    profileView: false,
  },
  {
    name: 'grade',
    label: 'Grade',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'grade',
    profileView: false,
  },
  {
    name: 'program',
    label: 'Program',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    param: 'program_id',
    profileView: false,
  },
  {
    name: 'studentState',
    label: 'State',
    fieldType: SELECT,
    required: true,
    editable: true,
    param: 'state',
    profileView: false,
    disabled: false,
  },
  {
    name: 'trial',
    label: 'Trial Type',
    fieldType: SELECT,
    required: false,
    editable: true,
    default: '',
    param: 'trial_type',
    disabled: true,
    profileView: false,
  },
  {
    name: 'classStartDate',
    label: ' Class Start Date',
    fieldType: INPUT,
    type: 'date',
    required: false,
    editable: true,
    default: null,
    param: 'class_start_date',
    profileView: false,
    display: 'none',
  },
  {
    name: 'classEndDate',
    label: 'Class End Date',
    fieldType: INPUT,
    type: 'date',
    required: false,
    editable: true,
    default: null,
    param: 'class_end_date',
    profileView: false,
  },
  {
    name: 'churn_reason',
    label: 'Churn Reason ',
    fieldType: SELECT,
    required: false,
    editable: true,
    default: '',
    param: 'churn_reason',
    profileView: false,
  },
  {
    name: 'churnDate',
    label: 'Churn Date',
    fieldType: INPUT,
    type: 'date',
    required: false,
    editable: true,
    default: null,
    param: 'churn_date',
    profileView: false,
  },
  {
    name: 'churnComments',
    label: 'Churn Comments',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'churn_comments',
    profileView: false,
  },
  {
    name: 'isDemo',
    label: 'Test Account',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_demo',
    profileView: false,
  },
  {
    name: 'isTeacherTraining',
    label: 'Teacher Training Account',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: STUDENT_TYPE.STUDENT,
    param: 'student_type',
    profileView: false,
  },
  {
    name: 'isRegionBanner',
    label: 'Payment Region Mismatch',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_region_policy_offender',
    profileView: false,
  },
];

export const addFilterFields = [
  {
    name: 'name',
    label: 'Name',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: null,
    param: 'name',
    maxlength: 25,
  },
  {
    name: 'description',
    label: 'Description',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'description',
    maxlength: 50,
  },
  {
    name: 'enabled',
    label: 'Enabled',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_live',
  },
];

export const studentProfileFields = [
  {
    name: 'region',
    label: 'Region',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'INDIA',
    param: 'region',
  },
  {
    name: 'competenceLevel',
    label: 'Competence Level',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'ANY',
    param: 'competence_level',
  },
  {
    name: 'personalityType',
    label: 'Personality Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'ANY',
    param: 'personality_type',
  },
  {
    name: 'teacherGender',
    label: 'Teacher Gender',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'ANY',
    param: 'teacher_gender',
  },
  {
    name: 'language',
    label: 'Preferred Language',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'ANY',
    param: 'preferred_language',
  },
  {
    name: 'primary_teacher_id',
    label: 'Primary Teacher Id',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'primary_teacher_id',
    disabled: false,
  },
  {
    name: 'secondary_teacher_id',
    label: 'Coding Teacher Id',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'secondary_teacher_id',
    disabled: false,
  },
  {
    name: 'comments',
    label: 'Comments',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'comments',
    profileView: false,
  },
];

export const studentDemoFields = [
  {
    name: 'student_id',
    label: 'Student Id',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: false,
    default: '',
    param: 'id',
    disabled: true,
    profileView: false,
  },
  {
    name: 'first_name',
    label: 'First Name',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'first_name',
    profileView: true,
  },
  {
    name: 'last_name',
    label: 'Last Name',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'last_name',
    profileView: false,
  },
  {
    name: 'grade',
    label: 'Grade',
    fieldType: INPUT,
    required: false,
    editable: true,
    default: null,
    param: 'grade',
    profileView: false,
  },
  {
    name: 'parent_name',
    label: 'Parent Name',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    default: '',
    param: 'parent_name',
    profileView: false,
  },
  {
    name: 'isPlusLead',
    label: 'Plus Lead',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    default: 'false',
    param: 'is_plus_lead',
    profileView: false,
  },
];

export const demoCancellationReasons = [
  {
    key: 'STABLE_WIFI_CONNECTION_ABSENT',
    text: 'The parent lacks a stable Wi-Fi connection.',
    value: 'STABLE_WIFI_CONNECTION_ABSENT',
  },
  {
    key: 'DEVICE_ISSUE_NO_LAPTOP_TABLET_ONLY',
    text: 'Device issue: no laptop, only a tablet available.',
    value: 'DEVICE_ISSUE_NO_LAPTOP_TABLET_ONLY',
  },
  {
    key: 'CHILD_SIGNED_UP_MISTAKE',
    text: 'The child signed up by mistake.',
    value: 'CHILD_SIGNED_UP_MISTAKE',
  },
  {
    key: 'PREFERENCE_OFFLINE_CLASSES',
    text: 'Preference for offline classes.',
    value: 'PREFERENCE_OFFLINE_CLASSES',
  },
  {
    key: 'PARENT_PREFERS_SPECIFIC_LANGUAGE_TEACHER',
    text: 'Parent prefers a teacher who speaks a specific language.',
    value: 'PARENT_PREFERS_SPECIFIC_LANGUAGE_TEACHER',
  },
  {
    key: 'PARENT_STOPPED_RESPONDING_INITIAL_CONVERSATION',
    text:
      'The parent stopped responding after the initial conversation with the teacher.',
    value: 'PARENT_STOPPED_RESPONDING_INITIAL_CONVERSATION',
  },
  {
    key: 'PARENT_WANTS_RESCHEDULE_LATER_DATE',
    text: 'The parent wants to reschedule to a later date.',
    value: 'PARENT_WANTS_RESCHEDULE_LATER_DATE',
  },
  {
    key: 'others',
    text: 'Others',
    value: 'others',
  },
];

export const studentCourseField = {
  name: 'studentCourse',
  label: 'Student Course',
  fieldType: SELECT,
  choices: [],
  required: true,
  editable: true,
  param: 'studentCourse',
};

export const studentSlotFields = [
  {
    name: 'slotType',
    label: 'Slot Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'REC',
    param: 'type',
  },
  {
    name: 'slotTag',
    label: 'Slot Tag',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'REGULAR',
    param: 'tag',
  },
  {
    name: 'startTime',
    label: 'Start Time',
    fieldType: INPUT,
    type: 'time',
    required: true,
    editable: true,
    default: '',
    param: 'start_time',
  },
  {
    name: 'startDate',
    label: 'Start Date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: '',
    param: 'start_date',
  },

  {
    name: 'endDate',
    label: 'End Date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: defaultDate,
    param: 'end_date',
  },
  {
    name: 'isDemo',
    label: 'Auto Enter',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_demo',
  },
];

export const teacherFields = [
  {
    name: 'teacher_id',
    label: 'Teacher Id',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    default: '',
    param: 'id',
    disabled: true,
  },
  {
    name: 'firstName',
    label: 'First Name',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'first_name',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: true,
    default: '',
    param: 'last_name',
  },
  {
    name: 'phone',
    label: 'Phone',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: false,
    default: '',
    param: 'phone',
  },
  {
    name: 'email',
    label: 'Email',
    fieldType: INPUT,
    type: 'email',
    required: true,
    editable: true,
    default: '',
    param: 'email',
  },
  {
    name: 'gender',
    label: 'Gender',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    param: 'gender',
  },
  {
    name: 'teacherState',
    label: 'State',
    fieldType: INPUT,
    required: true,
    editable: false,
    default: 'ACT',
    param: 'state',
  },
  {
    name: 'isDemo',
    label: 'Test Account',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_demo',
  },
  {
    name: 'inhouseTeacher',
    label: 'Inhouse Teacher',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_inhouse_teacher',
  },
  {
    name: 'centerTeacher',
    label: 'Center Teacher',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_center_teacher',
  },
  {
    name: 'higherTDSdeduction',
    label: 'Higher TDS deduction',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'higher_tds_deduction',
  },
];

export const teacherCredFields = [
  {
    name: 'teacherId',
    label: 'Teacher Id',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    default: '',
    param: 'teacher_id',
    disabled: true,
  },
  {
    name: 'cred',
    label: 'Cred',
    fieldType: SELECT,
    type: 'text',
    required: false,
    param: 'cred_id',
  },
  {
    name: 'credStatus',
    label: 'Status',
    fieldType: SELECT,
    type: 'text',
    required: false,
    editable: true,
    default: 'ACT',
    param: 'status',
  },
  {
    name: 'is_primary',
    label: 'Is Primary',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_primary',
    profileView: false,
  },
];

export const relationshipManagerFields = [
  {
    name: 'email',
    label: 'Email',
    fieldType: INPUT,
    type: 'email',
    required: true,
    profileView: true,
    param: 'email',
  },
  {
    name: 'rmTimezones',
    label: 'RM TimeZone',
    fieldType: SELECT,
    required: false,
    editable: true,
    multiple: true,
    param: 'rm_timezones',
  },
  {
    name: 'rmRegion',
    label: 'RM Region',
    fieldType: SELECT,
    required: true,
    editable: true,
    param: 'rm_region',
  },
  {
    name: 'rmManager',
    label: 'RM Manager',
    fieldType: SELECT,
    type: 'text',
    required: true,
    editable: true,
    param: 'manager_id',
  },
];

export const studentRegionsFormFields = [
  {
    name: 'studentRegions',
    label: 'Choose a Region',
    fieldType: SELECT,
    required: true,
    default: null,
    param: 'derived_region',
  },
];

export const teacherProfileFields = [
  {
    name: 'profilePic',
    label: 'Profile Pic',
    fieldType: INPUT,
    editable: true,
    default: '',
    param: 'profile_pic_url',
  },
  {
    name: 'aboutMe',
    label: 'About',
    fieldType: INPUT,
    editable: true,
    default: '',
    param: 'about_me',
  },
  {
    name: 'noOfClasses',
    label: 'No Of Classes',
    fieldType: INPUT,
    type: 'number',
    editable: false,
    default: 0,
    param: 'no_of_classes',
  },
];

export const DEFAULT_CLASS_DURATION = 55;

export const teacherSlotFeilds = [
  {
    name: 'slotType',
    label: 'Slot Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'REC',
    param: 'type',
  },
  {
    name: 'slotTag',
    label: 'Slot Tag',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'REGULAR',
    param: 'tag',
  },
  {
    name: 'day',
    label: 'Day',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    param: 'day',
    multiple: true,
  },
  {
    name: 'startTime',
    label: 'Start Time',
    fieldType: INPUT,
    type: 'time',
    required: true,
    editable: true,
    default: '',
    param: 'start_time',
  },

  {
    name: 'startDate',
    label: 'Start Date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: '',
    param: 'start_date',
  },
  {
    name: 'endDate',
    label: 'End Date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: defaultDate,
    param: 'end_date',
  },
  {
    name: 'duration',
    label: 'Duration',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: DEFAULT_CLASS_DURATION,
    param: 'duration',
  },
  {
    name: 'isDemo',
    label: 'Auto Enter',
    fieldType: FIELD_TYPES.CHECKBOX,
    type: 'checkbox',
    required: false,
    editable: true,
    default: false,
    param: 'is_demo',
  },
];

export const demoAutomationFields = [
  {
    name: 'slotType',
    label: 'Slot Type',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: 'SNG',
    param: 'type',
    disabled: true,
  },
  {
    name: 'slotTag',
    label: 'Slot Tag',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    param: 'tag',
  },
  {
    name: 'startDate',
    label: 'Start Date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: defaultLocalDate,
    param: 'start_date',
  },
  {
    name: 'startTime',
    label: 'Start Time',
    fieldType: INPUT,
    type: 'time',
    required: true,
    editable: true,
    default: defaultLocalTime,
    param: 'start_time',
  },
  {
    name: 'endDate',
    label: 'End Date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: false,
    default: defaultLocalDate,
    param: 'end_date',
    disabled: true,
  },
  {
    name: 'duration',
    label: 'Duration',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: DEFAULT_CLASS_DURATION,
    param: 'duration',
  },
  {
    name: 'day',
    label: 'Day',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: String(new Date().getDay() || 7),
    param: 'day',
    disabled: true,
  },
];

const subsPaymentFieldWidth = '288';
export const subscriptionPaymentFields = [
  {
    name: 'student_id',
    label: 'Student Id',
    fieldType: INPUT,
    required: true,
    editable: false,
    default: '',
    param: 'id',
    disabled: true,
    width: subsPaymentFieldWidth,
  },
  {
    name: 'product_type',
    label: 'Product',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'maths',
    param: 'product_type',
  },
  {
    name: 'online_band',
    label: 'Band',
    fieldType: FIELD_TYPES.SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'online_band',
    disabled: false,
  },
  {
    name: 'subscription_plan',
    label: 'Plan',
    fieldType: SELECT,
    required: true,
    editable: true,
    param: 'subscription_plan',
  },
  {
    name: 'enrollment_type',
    label: 'Enrollment Type',
    fieldType: FIELD_TYPES.INPUT,
    required: true,
    editable: false,
    default: '',
    param: 'enrollment_type',
    disabled: true,
    width: subsPaymentFieldWidth,
  },
  {
    name: 'currency',
    label: 'Currency Type',
    fieldType: FIELD_TYPES.INPUT,
    required: true,
    editable: false,
    default: ' ',
    param: 'currency',
    disabled: true,
    width: subsPaymentFieldWidth,
  },
  {
    name: 'amount',
    label: 'Setup Fee',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: null,
    param: 'amount',
    disabled: true,
    width: subsPaymentFieldWidth,
  },
  {
    name: 'amount_per_cycle',
    label: 'Installment Amount',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: false,
    default: null,
    param: 'amount_per_cycle',
    disabled: true,
    width: subsPaymentFieldWidth,
  },
  {
    name: 'duration',
    label: 'Installment cycles',
    fieldType: INPUT,
    required: true,
    editable: false,
    default: null,
    param: 'duration',
    disabled: true,
    width: subsPaymentFieldWidth,
  },
  {
    name: 'classes_per_week',
    label: 'Classes per week',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '2',
    disable: true,
    param: 'classes_per_week',
  },
  {
    name: 'payment_client',
    label: 'Payment client',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: 'PAYMENT_SERVICE',
    param: 'payment_client',
  },
  {
    name: 'teacher_id',
    label: 'Assign a teacher',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'teacher_id',
  },
];

const fieldWidth = '100%';
const labelMinWidth = '40%';
export const newPaymentFields = [
  {
    name: 'student_id',
    label: 'Student Id',
    fieldType: INPUT,
    required: true,
    editable: false,
    default: '',
    param: 'id',
    disabled: true,
    width: '340',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'online_band',
    label: 'Online Band',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'online_band',
    disabled: false,
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'grade_band',
    label: 'Grade',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'grade_band',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'course_type',
    label: 'Course Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'course_type',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'enrollment_type',
    label: 'Enrollment Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'enrollment_type',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'dynamic_duration',
    label: 'Duration',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'dynamic_duration',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'dynamic_class_ratio',
    label: 'Student to Teacher Ratio',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'dynamic_class_ratio',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'dynamic_no_of_classes',
    label: 'No. of Classes',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'dynamic_no_of_classes',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'teacher_id',
    label: 'Assign a teacher',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: null,
    param: 'teacher_id',
    width: '290',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'currency',
    label: 'Currency',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: false,
    default: null,
    param: 'currency',
    width: '340',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'amount',
    label: 'Amount',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: false,
    default: null,
    param: 'amount',
    width: '340',
    fieldWidth,
    labelMinWidth,
  },

  {
    name: 'payment_client',
    label: 'Payment client',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: 'PAYMENT_SERVICE',
    param: 'payment_client',
    width: '340',
    fieldWidth,
    labelMinWidth,
  },
  {
    name: 'coupon_code',
    label: 'Coupon Code',
    fieldType: INPUT,
    type: 'text',
    editable: true,
    required: false,
    default: null,
    param: 'coupon_code',
    width: '180',
    fieldWidth,
    labelMinWidth,
    justifyContent: 'flex-start',
    disabled: false,
  },
];

export const studentCourseEditFields = [
  {
    name: 'student_id',
    label: 'Student Id',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: null,
    param: 'student_id',
  },
  {
    name: 'student_course_update_reason',
    label: 'Reason',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'student_course_update_reason',
  },
  {
    name: 'remarks',
    label: 'Remarks',
    fieldType: INPUT,
    placeholder: 'ticket info / source of update',
    required: true,
    editable: true,
    default: null,
    param: 'remarks',
  },
  {
    name: 'classes_balance',
    label: 'Classes Balance',
    fieldType: INPUT,
    required: true,
    editable: true,
    default: '0',
    param: 'classes_balance',
  },
  {
    name: 'class_ratio',
    label: 'Class Ratio',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'class_ratio',
  },
  {
    name: 'classes_per_week',
    label: 'Classes Per Week',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'classes_per_week',
  },
  {
    name: 'primary_teacher_id',
    label: 'Primary Teacher Id',
    fieldType: INPUT,
    required: false,
    editable: true,
    default: null,
    param: 'primary_teacher_id',
  },
  {
    name: 'class_start_date',
    label: 'Class Start Date',
    fieldType: INPUT,
    type: 'date',
    required: false,
    editable: true,
    default: null,
    param: 'class_start_date',
  },
  {
    name: 'validity_till_date',
    label: 'Validity Date',
    fieldType: INPUT,
    type: 'date',
    required: false,
    editable: true,
    default: null,
    param: 'validity_till_date',
  },
];

export const courseDataFields = [
  {
    name: 'id',
    label: 'Course',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'id',
  },
  {
    name: 'duration',
    label: 'Duration',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'duration',
  },
  {
    name: 'enrollment_type',
    label: 'Enrollment Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: { value: REGULAR, label: REGULAR },
    param: 'enrollment_type',
  },
  {
    name: 'class_ratio',
    label: 'Student to Teacher Ratio',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'class_ratio',
  },
  {
    name: 'classes_per_week',
    label: 'Classes per week',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'classes_per_week',
  },
  {
    name: 'access_type',
    label: 'Access Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'access_type',
  },
];

export const addonDataFields = [
  {
    name: 'addon_course',
    label: 'Course',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'addon_course',
  },
  {
    name: 'addon_type',
    label: 'Addon Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'addon_type',
  },
  {
    name: 'addon_name',
    label: 'Addon Name',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'addon_name',
  },
  {
    name: 'comments',
    label: 'Comments',
    fieldType: INPUT,
    required: false,
    editable: true,
    default: null,
    param: 'comments',
  },
];

export const paymentDataFields = [
  {
    name: 'student_id',
    label: 'Student Id',
    fieldType: INPUT,
    required: true,
    editable: false,
    default: '',
    param: 'id',
    disabled: true,
  },
  {
    name: 'upload_payment_currency',
    label: 'Currency Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    param: 'currency',
    disabled: false,
  },
  {
    name: 'city',
    label: 'City',
    fieldType: INPUT,
    required: true,
    editable: true,
    default: null,
    param: 'city',
  },
  {
    name: 'amount',
    label: 'Amount',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: null,
    param: 'amount',
  },
  {
    name: 'payment_method',
    label: 'Payment Method',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: 'stripe',
    param: 'payment_client',
    disabled: false,
  },
  {
    name: 'paid_on',
    label: 'Paid on date',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: null,
    param: 'paid_on',
  },
  {
    name: 'invoice_id',
    label: 'Invoice Id',
    fieldType: INPUT,
    required: true,
    editable: true,
    default: null,
    param: 'invoice_id',
  },
  {
    name: 'teacher_id',
    label: 'Assign a teacher',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'teacher_id',
  },
];

export const indiaBillingInfoFields = [
  {
    name: 'pincode',
    label: 'Pin Code',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: null,
    param: 'pincode',
  },
  {
    name: 'indianState',
    label: 'State',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'state',
  },
];

export const internationalBillingInfoField = [
  {
    name: 'country',
    label: 'Country',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'country',
  },
];

export const assignElectiveFields = [
  {
    name: 'assignedTill',
    label: 'Courses Valid Till',
    fieldType: INPUT,
    type: 'date',
    required: true,
    editable: true,
    default: '',
    param: 'assigned_till',
  },
];

const prePrimaryGradeOptions = Object.keys(prePrimaryGrades).map(grade => ({
  label: prePrimaryGrades[grade],
  value: grade,
}));

const postPrimaryGradeOptions = Object.keys(postPrimaryGrades).map(grade => ({
  label: grade,
  value: grade,
}));

export const gradeOptions = prePrimaryGradeOptions.concat(postPrimaryGradeOptions);

export const studentCourseUpdateOptions = [
  {
    label: 'Sibling Payment',
    value: 'SIBLING_PAYMENT',
  },
  {
    label: 'No Payment',
    value: 'NO_PAYMENT',
  },
  {
    label: 'Sales Offer',
    value: 'SALES_OFFER',
  },
  {
    label: 'Pause Data',
    value: 'PAUSE_DATA',
  },
  {
    label: 'Migration Missed',
    value: 'MIGRATION_MISSED',
  },
  {
    label: 'Class ratio update',
    value: 'CLASS_RATIO_UPDATE',
  },
  {
    label: 'Classes per week update',
    value: 'CLASSES_PER_WEEK_UPDATE',
  },
];

export const studentStateOptions = [
  {
    label: 'Active',
    value: 'ACT',
  },
  {
    label: 'Trial',
    value: 'TRL',
  },
  {
    label: 'Inactive',
    value: 'INACT',
  },
  {
    label: 'Demo',
    value: 'DEMO',
  },
];

export const teacherStateOptions = [
  {
    label: 'Active',
    value: 'ACT',
  },
  {
    label: 'In-Training',
    value: 'INTR',
  },
  {
    label: 'Inactive',
    value: 'INACT',
  },
  {
    label: 'FINISHED_TRAINING',
    value: 'FDTR',
  },
];

export const rmStateOptions = [
  {
    label: 'Active',
    value: 'ACTIVE',
  },
  {
    label: 'Left',
    value: 'LEFT',
  },
  {
    label: 'On Leave',
    value: 'PAUSED',
  },
  {
    label: 'In Training',
    value: 'IN_TR',
  },
];

export const genderOptions = [
  {
    label: 'Male',
    value: 'MALE',
  },
  {
    label: 'Female',
    value: 'FEMALE',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
];

export const sourceValues = {
  PARENT_REFERRAL: 'Referral',
  SALES_REFERRAL: 'Sales-Referral',
  EMPLOYEE_REFERRAL: 'Employee-Referral',
  UAE_LOCAL: 'UAE-Local',
  ORGANIC: 'LEAP-ADMIN',
  SCRIPT: 'SCRIPT',
};

export const eventConstants = {
  EXHIBITION: 'Exhibition',
  MALL_ACTIVATION: 'Mall-Activation',
  SCHOOL_FAIRS: 'School-fairs',
  EMPLOYEE_REFERRAL: 'Employee-Referral',
  OTHER_EVENT: 'Other-event',
};

export const sourceOptions = [
  {
    label: 'UAE Local',
    value: sourceValues.UAE_LOCAL,
  },
  {
    label: 'Script',
    value: sourceValues.SCRIPT,
  },
];

export const referralOptions = [
  {
    label: 'Referral',
    value: sourceValues.PARENT_REFERRAL,
  },
];

export const leadSourceOptions = [
  {
    label: 'Referral',
    value: sourceValues.PARENT_REFERRAL,
  },
  {
    label: 'UAE Local',
    value: sourceValues.UAE_LOCAL,
  },
  {
    label: 'Organic',
    value: sourceValues.ORGANIC,
  },
];

export const organicLeadOptions = [
  {
    label: 'Referred by Inactive Parent',
    value: 'organic-inactive-parent',
  },
  {
    label: 'Social Media',
    value: 'organic-social-media',
  },
  {
    label: 'Teacher Reference',
    value: 'organic-teacher-reference',
  },
  {
    label: 'Ticket',
    value: 'organic-ticket',
  },
  {
    label: 'Inbound',
    value: 'inbound',
  },
];

export const eventOptions = [
  {
    label: 'Exhibition',
    value: eventConstants.EXHIBITION,
  },
  {
    label: 'Mall Activation',
    value: eventConstants.MALL_ACTIVATION,
  },
  {
    label: 'School Fairs',
    value: eventConstants.SCHOOL_FAIRS,
  },
  {
    label: 'Employee Referral',
    value: eventConstants.EMPLOYEE_REFERRAL,
  },
  {
    label: 'Other Event',
    value: eventConstants.OTHER_EVENT,
  },
];

export const studentSourceOptions = [
  {
    label: 'Referral',
    value: sourceValues.PARENT_REFERRAL,
  },
  {
    label: 'Organic',
    value: sourceValues.ORGANIC,
  },
  {
    label: 'UAE-Local',
    value: sourceValues.UAE_LOCAL,
  },
];

export const teacherGenderOptions = [
  {
    label: 'Male',
    value: 'MALE',
  },
  {
    label: 'Female',
    value: 'FEMALE',
  },
  {
    label: 'Any',
    value: 'ANY',
  },
];

export const teacherSlotTypeOptions = [
  {
    label: 'Recurring',
    value: 'REC',
  },
  {
    label: 'Single',
    value: 'SNG',
  },
];

export const rmTimezoneOptions = [
  {
    label: 'IST',
    value: 'IST',
  },
  {
    label: 'PST',
    value: 'PST',
  },
  {
    label: 'BST',
    value: 'BST',
  },
  {
    label: 'EST',
    value: 'EST',
  },
  {
    label: 'ANY',
    value: 'ANY',
  },
];

export const rmRegionOptions = [
  {
    label: 'India',
    value: 'INDIA',
  },
  {
    label: 'APAC',
    value: 'APAC',
  },
  {
    label: 'UK',
    value: 'UK',
  },
  {
    label: 'US',
    value: 'US',
  },
];

export const dayOptions = [
  {
    label: 'MON',
    value: '1',
  },
  {
    label: 'TUE',
    value: '2',
  },
  {
    label: 'WED',
    value: '3',
  },
  {
    label: 'THRS',
    value: '4',
  },
  {
    label: 'FRI',
    value: '5',
  },
  {
    label: 'SAT',
    value: '6',
  },
  {
    label: 'SUN',
    value: '7',
  },
];

export const OPTIONS = {
  ENROLLMENT_TYPE_ONLINE: 'enrollmentType',
  ENROLLMENT_TYPE_OFFLINE: 'enrollment_type',
  TEACHERSTATE: 'teacherState',
  TEACHERS_LIST: 'teachers_list',
  STUDENTSTATE: 'studentState',
  GRADE: 'grade',
  GENDER: 'gender',
  REGION: 'region',
  TEACHER_GENDER: 'teacherGender',
  PROGRAM: 'program',
  PREFERRED_LANGUAGE: 'language',
  COMPETENCE_LEVEL: 'competenceLevel',
  PERSONALITY_TYPE: 'personalityType',
  SLOT_TAG: 'slotTag',
  SLOT_TYPE: 'slotType',
  DAY: 'day',
  TRIAL: 'trial',
  CHURN_REASON: 'churn_reason',
  TEACHER_PROGRAMS: 'teacher_programs',
  DURATION: 'duration',
  DYNAMIC_DURATION: 'dynamic_duration',
  PRODUCT_TYPE: 'product_type',
  PAYMENT_TYPE: 'payment_type',
  CURRENCY: 'currency',
  UPLOAD_PAYMENT_CURRENCY: 'upload_payment_currency',
  ONLINE_BAND: 'online_band',
  GRADE_BAND: 'grade_band',
  COURSE: 'course',
  ONLINE_PLAN: 'online_plan',
  COURSE_TYPE: 'course_type',
  NO_OF_CLASSES: 'dynamic_no_of_classes',
  ADDON_TYPE: 'addon_type',
  ADDON_NAME: 'addon_name',
  ADDON_COURSE: 'addon_course',
  STUDENT_DEMO_STATE: 'studentDemoState',
  STUDENT_DEMO_LEAD_STATE: 'studentDemoLeadState',
  PARENT_SOURCE: 'parentSource',
  COUNTRY_CODE: 'countryCode',
  PAYMENT_METHOD: 'payment_method',
  CLASS_RATIO: 'class_ratio',
  DYNAMIC_CLASS_RATIO: 'dynamic_class_ratio',
  DYNAMIC_CLASSES_PER_WEEK: 'dynamic_classes_per_week',
  CLASSES_PER_WEEK: 'classes_per_week',
  PAYMENT_CLIENT: 'payment_client',
  SUBSCRIPTION_PLAN: 'subscription_plan',
  FILTERS: 'filters',
  ACCESS_TYPE: 'access_type',
  CRED_STATUS: 'credStatus',
  CRED: 'cred',
  STUDENT_COURSE: 'studentCourse',
  RM_TIMEZONES: 'rmTimezones',
  RM_REGION: 'rmRegion',
  RM_MANAGER: 'rmManager',
  STUDENT_COURSE_UPDATE_REASON: 'student_course_update_reason',
  INDIAN_STATES: 'indianState',
  COUNTRY: 'country',
  EMAIL: 'email',
  SOURCE: 'source',
  PHONE: 'phone',
  PARENT_NAME: 'parentName',
  SCHOOL_NAME: 'schoolName',
  EMPLOYEE_EMAIL: 'employeeEmail',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  REFERRER_COUNTRY_CODE: 'referrerCountryCode',
  REFERRER_PHONE: 'referrerPhone',
  REFEREE_COUNTRY_CODE: 'refereeCountryCode',
  REFEREE_PHONE: 'refereePhone',
  PLUS_LEAD: 'plusLead',
  ETHNICITY: 'ethnicity',
  SUCCESS_MODAL: 'successModal',
  EVENT_TYPE: 'event_type',
  EVENT_NAME: 'event_name',
  INFORMATION_SOURCE: 'information_source',
  MAPPING_MODEL_OPTIONS: 'mappingModel',
  TEACHER_STATE_OPTIONS: 'teacherStateOptions',
};

export const teacherStatus = {
  AVAILABLE: 'available',
  VIEW: 'view',
  ELIGIBLE: 'eligible',
  LIVE: 'live',
};

export const trialOptions = [
  {
    label: 'Trial-1 month',
    value: 'TRL_1MON',
  },
  {
    label: 'Trial- 1on1',
    value: 'TRL_1ON1',
  },
  {
    label: 'Trial- Leadsquare',
    value: 'TRL_LEADSQR',
  },
];

export const phoneNumberUpdates = [
  {
    name: 'countryCode',
    label: 'Country Code',
    fieldType: SELECT,
    required: false,
    editable: true,
    default: '',
    param: 'country_code',
  },
  {
    name: 'phone',
    label: 'Phone',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: '',
    param: 'phone',
    width: '230',
  },
];

export const AssignTeacherToLead = [
  {
    name: 'countryCode',
    label: 'Country Code',
    fieldType: SELECT,
    required: false,
    editable: true,
    default: '',
    param: 'country_code',
  },
  {
    name: 'phone',
    label: 'Phone',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: '',
    param: 'phone',
    width: '230',
  },
];

export const userNameUpdates = [
  {
    name: 'username',
    label: 'Username',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: false,
    default: '',
    param: 'username',
  },
  {
    name: 'confirmUsername',
    label: 'Confirm Username',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: false,
    default: '',
    param: 'username',
  },
];

export const teacherCredStateOptions = [
  {
    label: 'ACTIVE',
    value: 'ACT',
  },
  {
    label: 'PAUSED',
    value: 'PSD',
  },
  {
    label: 'INACTIVE',
    value: 'INACT',
  },
];

export const SlotStateOptions = [
  {
    label: 'Active',
    value: 'ACT',
  },
  {
    label: 'Future',
    value: 'FTR',
  },
  {
    label: 'Expired',
    value: 'EXP',
  },
];

export const paymentTenureOptions = Array.from(Array(25), (_, i) => {
  const monthVal = i !== 24 ? i + 1 : 36;
  return { value: monthVal, label: `${monthVal}-Months` };
});

export const productTypeOptions = [
  {
    label: 'Maths',
    value: 'MTH_ONLINE_WT_TCHR',
  },
  {
    label: 'Coding',
    value: 'CODING',
  },
];

export const paymentTypeOptions = [
  {
    label: 'One Time',
    value: 'ONE_TIME_PAYMENT',
  },
  {
    label: 'Subscription',
    value: 'SUBSCRIPTION',
  },
];

export const subscriptionPlanOptions = [
  {
    label: '11,999 - 3 months',
    value: '3',
  },
  {
    label: '6,499 - 6 months',
    value: '6',
  },
  {
    label: '4,499 - 9 months',
    value: '9',
  },
];

export const paymentClientOptions = [
  {
    label: 'Cuemath Web Link',
    value: 'PAYMENT_SERVICE',
  },
];

export const paymentMethodOptions = [
  {
    label: 'Zest loan',
    value: 'zest_loan',
  },
  {
    label: 'Propelld',
    value: 'propelld',
  },
  {
    label: 'Eduvanz',
    value: 'eduvanz',
  },
  {
    label: 'Bajaj FinServ',
    value: 'bajaj_finserv',
  },
  {
    label: 'Early Salary',
    value: 'early_salary',
  },
  {
    label: 'Stripe',
    value: 'stripe',
  },
  {
    label: 'Bank Transfer',
    value: 'bank_transfer',
  },
];

export const enrollmentTypeOfflineOptions = [
  { label: REGULAR, value: REGULAR },
  { label: PLUS, value: PLUS },
  { label: 'HYBRID', value: 'HYBRID' },
  { label: 'HYBRID PLUS', value: 'HYBRID_PLUS' },
  { label: 'CLASS_K5', value: 'CLASS_K5' },
  { label: 'HIGH', value: 'HIGH' },
  { label: 'CUECENTER', value: 'CUECENTER' },
  { label: 'IBG', value: 'IBG' },
];

export const studentDemoLeadStateOptions = [
  {
    label: 'NEW',
    value: 'NEW',
  },
  {
    label: 'INTERESTED',
    value: 'INTERESTED',
  },
  {
    label: 'READY_TO_PAY',
    value: 'READY_TO_PAY',
  },
  {
    label: 'FUTURE_POTENTIAL',
    value: 'FUTURE_POTENTIAL',
  },
  {
    label: 'NOT_INTERESTED',
    value: 'NOT_INTERESTED',
  },
  {
    label: 'PAID',
    value: 'PAID',
  },
  {
    label: 'REASSIGNED',
    value: 'REASSIGNED',
  },
  {
    label: 'PAID_TO_OTHER',
    value: 'PAID_TO_OTHER',
  },
];

export const studentDemoStateOptions = [
  {
    label: 'REQUESTED',
    value: 'REQUESTED',
  },
  {
    label: 'SCHEDULED',
    value: 'SCHEDULED',
  },
  {
    label: 'RESCHEDULED',
    value: 'RESCHEDULED',
  },
  {
    label: 'NOT_DONE',
    value: 'NOT_DONE',
  },
  {
    label: 'DONE',
    value: 'DONE',
  },
  {
    label: 'REDO',
    value: 'REDO',
  },
  {
    label: 'CANCELLED',
    value: 'CANCELLED',
  },
];

export const parentSourceOptions = [
  {
    label: 'CUEMATH',
    value: 'CUEMATH',
  },
  {
    label: 'TEACHER',
    value: 'TEACHER',
  },
];

export const classRatioOptions = [
  {
    label: '1:1',
    value: 1,
  },
  {
    label: '1:2',
    value: 2,
  },
  {
    label: '1:4',
    value: 4,
  },
  {
    label: '1:6',
    value: 6,
  },
];

export const classesPerWeekOptions = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
];

export const addSheetFields = [
  {
    name: 'node_types',
    label: 'Type',
    fieldType: SELECT,
    editable: true,
    default: '',
    param: 'node_type',
  },
  {
    name: 'grades',
    label: 'Grades',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'grades',
  },
  {
    name: 'boards',
    label: 'Board',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'boards',
  },
  {
    name: 'topics',
    label: 'Topics',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'topics',
  },
  {
    name: 'name',
    label: 'Name',
    fieldType: INPUT,
    required: true,
    type: 'text',
    editable: true,
    default: '',
    param: 'name',
    maxlength: 50,
  },
  {
    name: 'reference',
    label: 'Reference',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'learnosity_activity_ref',
  },
];

export const addCardFields = [
  {
    name: 'activity_types',
    label: 'Type',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'activity_types',
  },
  {
    name: 'grades',
    label: 'Grades',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'grades',
  },
  {
    name: 'activity_tiles',
    label: 'Tiles',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'activity_tiles',
  },
  {
    name: 'activity_topics',
    label: 'Topics',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'activity_topics',
  },
  {
    name: 'name',
    label: 'Name',
    fieldType: INPUT,
    required: true,
    type: 'text',
    editable: true,
    default: '',
    param: 'name',
    maxlength: 50,
  },
];

export const bulkEditSheetFields = [
  {
    name: 'node_types',
    label: 'Type',
    fieldType: SELECT,
    editable: true,
    default: '',
    param: 'node_type',
    value: 'TYPE',
  },
  {
    name: 'grades',
    label: 'Grades',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'grades',
    value: 'GRADES',
  },
  {
    name: 'boards',
    label: 'Board',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'boards',
    value: 'BOARDS',
  },
  {
    name: 'topics',
    label: 'Topics',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: '',
    multiple: true,
    param: 'topics',
    value: 'TOPICS',
  },
  {
    name: 'is_live',
    label: 'Is live',
    fieldType: RADIO,
    required: true,
    type: 'text',
    editable: true,
    default: '',
    param: 'is_live',
    value: 'IS_LIVE',
  },
  {
    name: 'location',
    label: 'Location',
    fieldType: RADIO,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'location',
    value: 'LOCATION',
  },
  {
    name: 'is_timed',
    label: 'Is timed',
    fieldType: RADIO,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'is_timed',
    value: 'IS_TIMED',
  },
  {
    name: 'time',
    label: 'Time',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: '',
    param: 'time',
    placeholder: 'min',
    value: 'TIME',
  },
  {
    name: 'completion_criteria',
    label: 'Completion criteria',
    fieldType: CRITERIA,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'completion_criteria',
    value: 'COMPLETION_CRITERIA',
  },
  {
    name: 'reattempt_criteria',
    label: 'Reattempt criteria',
    fieldType: CRITERIA,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'reattempt_criteria',
    value: 'REATTEMPT_CRITERIA',
  },
  {
    name: 'complete_in',
    label: 'Complete in',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: '',
    param: 'complete_in',
    placeholder: 'days',
    value: 'DAYS',
  },
  {
    name: 'reattempt_in',
    label: 'Reattempt in',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: '',
    param: 'reattempt_in',
    placeholder: 'hours',
    value: 'HOURS',
  },
];

export const subscriptionCurrencyOptions = [
  {
    label: 'USD',
    value: 'USD',
  },
];

export const uploadPaymentCurrencyOptions = [
  {
    label: 'AED',
    value: 'AED',
  },
  {
    label: 'AUD',
    value: 'AUD',
  },
  {
    label: 'CAD',
    value: 'CAD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'INR',
    value: 'INR',
  },
  {
    label: 'JPY',
    value: 'JPY',
  },
  {
    label: 'MYR',
    value: 'MYR',
  },
  {
    label: 'NZD',
    value: 'NZD',
  },
  {
    label: 'QAR',
    value: 'QAR',
  },
  {
    label: 'SAR',
    value: 'SAR',
  },
  {
    label: 'HKD',
    value: 'HKD',
  },
  {
    label: 'SGD',
    value: 'SGD',
  },
  {
    label: 'THB',
    value: 'THB',
  },
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'KWD',
    value: 'KWD',
  },
  {
    label: 'BHD',
    value: 'BHD',
  },
  {
    label: 'OMR',
    value: 'OMR',
  },
  {
    label: 'SEK',
    value: 'SEK',
  },
  {
    label: 'CHF',
    value: 'CHF',
  },
];

export const accessTypeOptions = [
  {
    label: 'WITH_TEACHER',
    value: 'WITH_TEACHER',
  },
  {
    label: 'WITHOUT_TEACHER',
    value: 'WITHOUT_TEACHER',
  },
];

export const COURSE_CLASS_LOG_ACTION_FORM_FIELDS = [
  {
    name: 'classDate',
    label: 'Class Date',
    fieldType: INPUT,
    required: false,
    editable: false,
    disabled: true,
    default: '',
    param: 'class_taken_on',
  },
  {
    name: 'classTime',
    label: 'Class Time',
    fieldType: INPUT,
    required: false,
    editable: false,
    disabled: true,
    default: '',
    param: 'class_taken_on',
  },
  {
    name: 'classType',
    label: 'Class Type',
    fieldType: INPUT,
    required: false,
    editable: false,
    disabled: true,
    default: '',
    param: 'class_Type',
  },
  {
    name: 'logId',
    label: 'Log Id',
    fieldType: INPUT,
    required: false,
    editable: false,
    disabled: true,
    default: '',
    param: 'class_log_id',
  },
  {
    name: 'action',
    label: 'Action',
    fieldType: SELECT,
    required: true,
    editable: true,
    param: 'action',
  },
  {
    name: 'reason',
    label: 'Reason',
    fieldType: INPUT,
    type: 'text',
    required: true,
    editable: true,
    default: '',
    param: 'reason',
  },
];

export const COURSE_CLASS_LOGS_ACTION_OPTIONS = [
  {
    label: 'Mark Class Invalid',
    value: 'mark_invalid',
  },
  {
    label: 'Revert Student No show',
    value: 'revert_student_no_show',
  },
  {
    label: 'Revert Student No show and clawback teacher payout',
    value: 'revert_student_no_show_with_payout',
  },
];

const GradeArr = Object.keys(GRADES);

export const GradeOptions = GradeArr.map(item => ({
  label: GRADES[item],
  value: item,
}));

export const PlusLeadOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const EthnicityOptions = [
  { label: 'Indian', value: 'Indian' },
  { label: 'Native', value: 'Native' },
  { label: 'Other', value: 'Others' },
];

export const studentUpgradeFields = [
  {
    name: 'discount_amount',
    label: 'Pending Amount',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'pending_classes',
    label: 'Classes Left',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'enrollment_type',
    label: 'Enrollment Type',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
  {
    name: 'online_band_list',
    label: 'Online Band',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
  {
    name: 'online_plan',
    label: 'Online Plans',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
];

export const studentUpgradeFieldsV2 = [
  {
    name: 'discount_amount',
    label: 'Pending Amount',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'pending_classes',
    label: 'Classes Left',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'to_enrollment_type',
    label: 'To Enrollment Type',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
  {
    name: 'class_ratio',
    label: 'To Class Ratio',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
  {
    name: 'classes_per_week',
    label: 'To Classes Per Week',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
];

export const studentTrialUpgradeFields = [
  {
    name: 'discount_amount',
    label: 'Pending Amount',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'pending_classes',
    label: 'Classes Left',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
];

export const studentUpgradeV2Fields = [
  {
    name: 'unused_balance',
    label: 'Unused Balance',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: 0,
    disabled: true,
    profileView: true,
  },
  {
    name: 'classes_left',
    label: 'Classes Left',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: 0,
    disabled: true,
    profileView: true,
  },
];

export const studentRevertUpgradePaymentLinkFields = [
  {
    name: 'online_band_list',
    label: 'Online Band',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: false,
    choices: [],
    profileView: true,
  },
];

export const studentTransferClassesFields = [
  {
    name: 'pending_classes',
    label: 'Classes',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'unserviced_amount',
    label: 'Amount',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'online_band_list',
    label: 'Online Band',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: false,
    choices: [],
    profileView: true,
  },
  {
    name: 'students',
    label: 'Students',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
  {
    name: 'student_course',
    label: 'Student Course',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
];

export const studentTransferPartialClassesFields = [
  {
    name: 'pending_classes',
    label: 'Classes',
    fieldType: INPUT,
    required: false,
    editable: false,
    default: '',
    disabled: true,
    profileView: true,
  },
  {
    name: 'classes_to_transfer',
    label: 'No. of classes to transfer',
    fieldType: INPUT,
    type: 'number',
    required: true,
    editable: true,
    default: '',
    param: 'classes_to_transfer',
    min: 1,
    step: 1,
  },
  {
    name: 'online_band_list',
    label: 'Online Band',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: false,
    choices: [],
    profileView: true,
  },
  {
    name: 'students',
    label: 'Students',
    fieldType: SELECT,
    required: true,
    editable: false,
    default: '',
    disabled: true,
    choices: [],
    profileView: true,
  },
  {
    name: 'course',
    label: 'Course',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'id',
    choices: [],
  },
  {
    name: 'to_enrollment_type',
    label: 'To Enrollment Type',
    fieldType: SELECT,
    required: false,
    editable: false,
    default: '',
    disabled: false,
    choices: enrollmentTypeOfflineOptions,
    profileView: true,
  },
  {
    name: 'class_ratio',
    label: 'To Class Ratio',
    fieldType: SELECT,
    required: false,
    editable: false,
    default: '',
    disabled: false,
    choices: classRatioOptions,
    profileView: true,
  },
  {
    name: 'teacher_id',
    label: 'Assign a teacher',
    fieldType: SELECT,
    required: true,
    editable: true,
    default: null,
    param: 'teacher_id',
    choices: [],
  },
];

export const MAPPING_MODEL_OPTIONS = [
  { value: 'BACKEND', label: 'Algorithm' },
  { value: 'ML', label: 'Machine Learning' },
];

export const emiOptionsLabel = 'Show EMI options';

export const TRIAL_PROFILE_FIELDS = [
  {
    name: 'training_completed_on',
    label: 'Training Completed On',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    defaultValue: 'NA',
    param: 'training_completed_on',
    disabled: true,
    width: '233',
  },
  {
    name: 't2p_rate',
    label: 'T2P Rate',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    defaultValue: '0',
    param: 't2p_rate',
    disabled: true,
    width: '233',
  },
  {
    name: 'retention_rate',
    label: 'Retention Rate',
    fieldType: INPUT,
    type: 'text',
    required: false,
    editable: false,
    defaultValue: 'NA',
    param: 'retention_rate',
    disabled: true,
    width: '233',
  },
  {
    name: 'ir_score',
    label: 'IR Score (1-10)',
    fieldType: INPUT,
    type: 'number',
    required: false,
    editable: true,
    defaultValue: '',
    param: 'ir_score',
    disabled: false,
    width: '233',
  },
  {
    name: 'tr_score',
    label: 'TR Score (1-10)',
    fieldType: INPUT,
    type: 'number',
    required: false,
    editable: true,
    defaultValue: '',
    param: 'tr_score',
    disabled: false,
    width: '233',
  },
  {
    name: 'professional_review',
    label: 'Professional Review',
    fieldType: SELECT,
    required: false,
    editable: true,
    defaultValue: '',
    param: 'professional_review',
    disabled: false,
    choices: [
      { value: 'GREEN', label: 'GREEN' },
      { value: 'AMBER', label: 'AMBER' },
      { value: 'RED', label: 'RED' },
    ],
    width: '233',
  },
  {
    name: 'state',
    label: 'State',
    fieldType: SELECT,
    required: false,
    editable: true,
    defaultValue: '',
    param: 'state',
    disabled: false,
    choices: [
      { value: 'TRAINING_IN_PROGRESS', label: 'TRAINING IN PROGRESS' },
      { value: 'TRAINING_COMPLETE', label: 'TRAINING COMPLETE' },
      { value: 'TRAINING_FAILED', label: 'TRAINING FAILED' },
      { value: 'TRAINING_AWAITING_FEEDBACK', label: 'TRAINING AWAITING FEEDBACK' },
      { value: 'ACTIVE_TUTOR', label: 'ACTIVE TUTOR' },
      { value: 'TRIALS_SUSPENDED', label: 'TRIALS SUSPENDED' },
    ],
    width: '233',
  },
];

export const TRAINING_COMPLETED_VERSION = {
  name: 'training_completed_version',
  label: 'Training Completed Version',
  fieldType: SELECT,
  required: true,
  editable: true,
  defaultValue: '',
  param: 'training_completed_version',
  disabled: false,
  choices: [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
  ],
  width: '233',
};

export const TEACHER_STATE_CHANGE_REASON = {
  name: 'state_reason',
  label: 'State Change Reason',
  fieldType: INPUT,
  type: 'text',
  required: true,
  editable: true,
  defaultValue: '',
  param: 'state_reason',
  disabled: false,
  width: '233',
};
